import { openRulesModal } from './rules-modal.js'; 
import { launchTutorial } from './krida-tutorial.js';
import { openScoringModal } from './scoring-modal.js';
import { ThemeManager } from './theme-manager.js';
import { openOptionsModal } from './krida-ui-options.js';
// Assuming KridaMain might expose KridaUIOptionsModal.open() or similar for options
// Assuming a way to navigate for 'back-to-board'


let navDrawer = null;
let overlay = null;
let navDrawerList = null;
let closeNavBtn = null;
let hamburgerMenu = null;

export function openDrawer() {
  if (navDrawer) navDrawer.classList.add('open');
  if (overlay) overlay.classList.add('active');
}

export function closeDrawer() {
  if (navDrawer) navDrawer.classList.remove('open');
  if (overlay) overlay.classList.remove('active');
}

export function refreshThemeSelectorUI() {
    const container = document.getElementById('theme-selector-container');
    if (!container) {
        return;
    }

    const allThemes = ThemeManager.getAllThemes();
    const unlockedThemes = ThemeManager.getAvailableThemes();
    const currentTheme = ThemeManager.getCurrentTheme();

    if (!allThemes || allThemes.length === 0) {
        container.innerHTML = '<p>No themes available.</p>';
        return;
    }

    let themeOptionsHTML = '';
    allThemes.forEach(theme => {
        const isUnlocked = unlockedThemes.includes(theme);
        const isCurrentTheme = theme === currentTheme;
        const themeDisplayName = theme.charAt(0).toUpperCase() + theme.slice(1);
        const classes = ['theme-option-item'];
        if (isCurrentTheme) classes.push('current-theme');
        if (!isUnlocked) classes.push('locked');
        themeOptionsHTML += `
            <div class="${classes.join(' ')}" data-theme="${theme}">
                ${isUnlocked ? themeDisplayName : `&#x1f512; ${themeDisplayName}`}
            </div>
        `;
    });
    container.innerHTML = themeOptionsHTML;

    // Add event listeners only to unlocked theme options
    const themeItems = container.querySelectorAll('.theme-option-item:not(.locked)');
    themeItems.forEach(item => {
        item.addEventListener('click', (event) => {
            const clickedElement = event.target.closest('.theme-option-item');
            const selectedTheme = clickedElement ? clickedElement.getAttribute('data-theme') : null;
            if (!selectedTheme) {
                return;
            }
            ThemeManager.setTheme(selectedTheme);
            refreshThemeSelectorUI();
        });
    });
}

async function loadSharedNavContent() {
  if (!navDrawerList) return;
  try {
    const response = await fetch('/nav-drawer-content.html');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const html = await response.text();
    navDrawerList.innerHTML = html; // Set the shared content
    refreshThemeSelectorUI(); // <-- NEW: Call setup for themes
  } catch (error) {
    console.error('Could not load shared nav content:', error);
    if (navDrawerList) navDrawerList.innerHTML = '<li>Error loading menu.</li>';
  }
}

function getCurrentPage() {
    const path = window.location.pathname;
    if (path.includes('krida.html')) {
        return 'game';
    } else if (path.includes('dashboard.html')) {
        return 'dashboard';
    }
    // Add other pages as needed
    return 'unknown';
}

function getPageSpecificItems() {
    const page = getCurrentPage();
    const items = [];

    if (page === 'game') {
        items.push({
            id: 'nav-game-options-btn',
            text: 'Game Options',
            handler: () => {
                openOptionsModal(); // Open the existing options modal
                closeDrawer();
            }
        });
        // Here, you would also add a function to check if the game is a tournament
        // and disable the button if needed.
        // e.g., updateGameOptionsButtonState(gameData);
    }

    // You can add more 'else if (page === ...)' blocks here for other pages

    return items;
}

// Attaches event handlers to all known buttons in the nav drawer (shared and page-specific)
function setupNavButtonHandlers(pageSpecificItemsConfig = []) {
    // --- Handlers for SHARED items (IDs from nav-drawer-content.html) ---
    const sharedTutorialBtn = document.getElementById('nav-tutorial-btn');
    if (sharedTutorialBtn) {
        sharedTutorialBtn.replaceWith(sharedTutorialBtn.cloneNode(true));
        document.getElementById('nav-tutorial-btn').addEventListener('click', () => {
            const subMenu = document.getElementById('tutorial-sub-menu');
            if (subMenu) {
                const isHidden = getComputedStyle(subMenu).display === 'none';
                subMenu.style.display = isHidden ? 'block' : 'none';
            }
        });
    }

    // Tutorial sub-menu buttons
    const tutorialSubButtons = {
        'nav-tutorial-full': 'fullTutorial',
        'nav-tutorial-sow': 'sow',
        'nav-tutorial-harvest': 'harvest',
        'nav-tutorial-stockpile': 'stockpile',
        'nav-tutorial-scoring': 'scoring'
    };
    Object.entries(tutorialSubButtons).forEach(([btnId, tutorialName]) => {
        const btn = document.getElementById(btnId);
        if (btn) {
            btn.addEventListener('click', () => {
                launchTutorial(tutorialName);
                closeDrawer();
            });
        }
    });

    const sharedRulesBtn = document.getElementById('nav-rules-btn');
    if (sharedRulesBtn) {
        sharedRulesBtn.replaceWith(sharedRulesBtn.cloneNode(true)); // Clear old listeners
        document.getElementById('nav-rules-btn').addEventListener('click', async () => {
            await openRulesModal();
            closeDrawer();
        });
    }

    const sharedScoringBtn = document.getElementById('nav-scoring-btn');
    if (sharedScoringBtn) {
        sharedScoringBtn.replaceWith(sharedScoringBtn.cloneNode(true)); // Clear old listeners
        document.getElementById('nav-scoring-btn').addEventListener('click', () => {
            openScoringModal();
            closeDrawer();
        });
    }

    const sharedThemeBtn = document.getElementById('nav-theme-btn');
    if (sharedThemeBtn) {
        sharedThemeBtn.replaceWith(sharedThemeBtn.cloneNode(true)); // Clear old listeners
        document.getElementById('nav-theme-btn').addEventListener('click', () => {
            // Theme button doesn't need to do anything - themes are clickable below it
            // Could potentially collapse/expand theme options in the future
        });
    }


    // Add other shared button handlers here if nav-drawer-content.html has more items

    // --- Add and attach handlers for PAGE-SPECIFIC items ---
    // These are appended to the navDrawerList which already contains shared items
    pageSpecificItemsConfig.forEach(item => {
        if (!navDrawerList) return;
        const listItem = document.createElement('li');
        const button = document.createElement('button');
        button.id = item.id;
        button.textContent = item.text;
        if (item.handler) {
            // The handler from the config already includes closeDrawer()
            button.addEventListener('click', item.handler); 
        }
        listItem.appendChild(button);
        navDrawerList.appendChild(listItem);
    });
}

export async function initNavDrawer(pageSpecificItemsConfig = []) {
  navDrawer = document.getElementById('nav-drawer');
  overlay = document.getElementById('overlay');
  navDrawerList = document.querySelector('#nav-drawer ul');
  closeNavBtn = document.getElementById('close-nav-btn');
  hamburgerMenu = document.getElementById('hamburger-menu');

  if (!navDrawer || !overlay || !navDrawerList || !closeNavBtn || !hamburgerMenu) {
    console.error('Nav drawer elements not all found. Navigation will be broken.');
    return;
  }

  // Debounce or ensure listeners are added only once or are idempotent
  // Simple way: clone and replace to remove old listeners before adding new ones
  // For hamburger, overlay, closeNavBtn, this is safer if initNavDrawer could be called multiple times.
  // However, for this app's structure, it's likely called once per page load.
  
  // Ensure clean listeners for primary controls
  const cleanHamburger = hamburgerMenu.cloneNode(true);
  hamburgerMenu.parentNode.replaceChild(cleanHamburger, hamburgerMenu);
  hamburgerMenu = cleanHamburger;
  hamburgerMenu.addEventListener('click', openDrawer);

  const cleanOverlay = overlay.cloneNode(true);
  overlay.parentNode.replaceChild(cleanOverlay, overlay);
  overlay = cleanOverlay;
  overlay.addEventListener('click', closeDrawer); 

  const cleanCloseNavBtn = closeNavBtn.cloneNode(true);
  closeNavBtn.parentNode.replaceChild(cleanCloseNavBtn, closeNavBtn);
  closeNavBtn = cleanCloseNavBtn;
  closeNavBtn.addEventListener('click', closeDrawer);
  
  await loadSharedNavContent(); // Load shared HTML items into the UL
  const pageSpecificItems = getPageSpecificItems(); // Get items for the current page
  setupNavButtonHandlers(pageSpecificItems); // Attach handlers to shared items AND add/attach handlers for page-specific ones

  // Listen for theme changes TO UPDATE THE THEME SELECTOR, not to reload the list
  document.addEventListener('theme-changed', (e) => {
      // Refresh the theme selector UI to update the current theme highlighting
      refreshThemeSelectorUI();
  });

} 